import React from "react";
import VideoUpload from "./VideoUpload";

const VideoUploadPage: React.FC = () => {
  return <VideoUpload />;
};

export default VideoUploadPage;
